import { useTranslation } from 'react-i18next';
import type { ConfidenceLevel } from '../../types/api';

interface BadgeProps {
  label: string;
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info';
  className?: string;
}

const variants = {
  default: 'bg-gray-100 text-gray-700',
  success: 'bg-success-50 text-success-600',
  warning: 'bg-warning-50 text-warning-600',
  danger: 'bg-danger-50 text-danger-500',
  info: 'bg-primary-50 text-primary-600',
};

export function Badge({ label, variant = 'default', className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${variants[variant]} ${className}`}
    >
      {label}
    </span>
  );
}

const confidenceVariants: Record<ConfidenceLevel, BadgeProps['variant']> = {
  struggling: 'danger',
  on_track: 'warning',
  confident: 'success',
};

export function ConfidenceBadge({ level }: { level: ConfidenceLevel }) {
  const { t } = useTranslation();
  const confidenceLabels: Record<ConfidenceLevel, string> = {
    struggling: t('confidence.struggling'),
    on_track: t('confidence.on_track'),
    confident: t('confidence.confident'),
  };
  return <Badge label={confidenceLabels[level]} variant={confidenceVariants[level]} />;
}
